// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o7Eiz47K0ojJRVnuhUQy {
  font-style: italic;
  color: rgb(25, 118, 210);
}
`, "",{"version":3,"sources":["webpack://./src/style/editor.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B","sourcesContent":[".badge {\n  font-style: italic;\n  color: rgb(25, 118, 210);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `o7Eiz47K0ojJRVnuhUQy`
};
export default ___CSS_LOADER_EXPORT___;
